<template>
<div>收益</div>
</template>

<script>
export default {
name: "invome"
}
</script>

<style scoped>

</style>
